<script setup>
defineProps({
  servizi: {
    type: Array,
    default: () => [],
  },
  ambito: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div class="in-ambiti-servizi-list row-400-20 max p-bot-1">
    <div class="container">
      <h2 class="heading-1 title">I servizi DigitXS per l'area {{ ambito }}</h2>
      <div v-if="servizi.length > 0" class="text-2">
        <ul class="list">
          <li
            v-for="(item, index) in servizi"
            :key="index"
            class="ambito"
            :class="{ 'last-element': index === servizi.length - 1 }"
          >
            <nuxt-link
              v-if="item.slug"
              class="text-3"
              :to="
                $localePath({
                  name: 'servizi-slug',
                  params: { slug: item.slug },
                })
              "
            >
              <div v-if="item.titolo" class="icon-link-animation">
                {{ item.titolo }}
                <img
                  src="@/assets/img/ico/arrows-color2.svg"
                  alt="Icon"
                  class="icon"
                />
              </div>
            </nuxt-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmbitiServiziList',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
